
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, Eye, MoreHorizontal } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface ArticlesListProps {
  searchQuery: string;
}

const ArticlesList = ({ searchQuery }: ArticlesListProps) => {
  // Mock data - would typically come from an API
  const articles = [
    { id: 1, title: 'Product-Led Growth Strategies', status: 'published', author: 'Admin User', date: '2023-08-15', category: 'Product' },
    { id: 2, title: 'Community Building Best Practices', status: 'published', author: 'Editor User', date: '2023-09-02', category: 'Community' },
    { id: 3, title: 'Marketing Trends for 2024', status: 'draft', author: 'Admin User', date: '2023-10-10', category: 'Marketing' },
    { id: 4, title: 'Building Effective Sales Enablement', status: 'published', author: 'Editor User', date: '2023-11-05', category: 'Business' },
    { id: 5, title: 'Content Strategy for SaaS', status: 'draft', author: 'Admin User', date: '2023-12-01', category: 'Marketing' },
  ];
  
  const filteredArticles = searchQuery 
    ? articles.filter(article => 
        article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        article.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
        article.author.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : articles;
  
  return (
    <Card>
      <div className="p-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Title</TableHead>
              <TableHead>Category</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Author</TableHead>
              <TableHead>Date</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <TableRow key={article.id}>
                  <TableCell className="font-medium">{article.title}</TableCell>
                  <TableCell>{article.category}</TableCell>
                  <TableCell>
                    <Badge variant={article.status === 'published' ? 'default' : 'outline'}>
                      {article.status}
                    </Badge>
                  </TableCell>
                  <TableCell>{article.author}</TableCell>
                  <TableCell>{article.date}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button variant="ghost" size="icon">
                        <Eye className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="icon">
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="icon">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-6">
                  No articles found matching your search criteria
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default ArticlesList;
